import * as React from 'react';
import { useTranslation } from 'react-i18next';

import Avatar from './Avatar/Avatar';

import { useApplication } from '../AppContext';

const GamerTag = ({ player, showOnline = false }) => {

	const { t } = useTranslation();

	const app = useApplication();

	const handleClick = React.useCallback(() => {
		app?.navigate?.('Profile');
	}, [app]);

	const line1 = React.useMemo(() => {
		if (showOnline) {
			return (
				<>
					🏆
					<span data-model="userdata" data-inner-text="rank">{player?.rank ?? 0}</span>{' '}
					(<span data-model="userdata" data-inner-text="rating">{player?.rating ?? 0}</span>)
				</>
			);
		}

		return (
			<>
				⭐
				<span data-model="resource" data-inner-text="Level">{t('Level')}</span> <span data-model="userdata" data-inner-text="level">{player?.level ?? 1}</span>
			</>
		);
	}, [player?.level, player?.rank, player?.rating, showOnline, t]);

	const line2 = React.useMemo(() => {
		if (showOnline) {
			return (
				<>
					{/* <span>✉️ {t('Invite Code')}: </span>
					<span>{player?.inviteCode}</span> */}
				</>
			);
		}

		return (
			<>

				🏆
				<progress
					className="progress"
					max="1"
					data-model="userdata"
					data-value="achievementProgress"
					value={player?.achievementProgress ?? 0}
				/>
			</>
		);
	}, [player?.achievementProgress, showOnline]);

	const coins = React.useMemo(() => {
		if (!showOnline) {
			return (
				<div className="coins">{player?.coins ?? 0}</div>
			);
		}

		return null;

	}, [player?.coins, showOnline]);

	return (
		<div className="gamerTag" onClick={handleClick}>
			<Avatar avatar={player?.avatar} />
			{coins}
			<div className="title">
				{player.name}
			</div>
			<div className="description">
				{line1}
			</div>
			<div className="description">
				{line2}
			</div>
		</div>
	);

};

export default React.memo(GamerTag);
